<section class="modal-shell" [ngClass]="'modal-shell--' + size" [class.modal-shell--sop]="sopMode" role="dialog" [attr.aria-label]="title">
  <header class="modal-shell-header">
    <div *ngIf="subtitle; else plainTitle" class="modal-shell-heading">
      <h2>{{ title }}</h2>
      <p class="modal-shell-subtitle">{{ subtitle }}</p>
    </div>
    <ng-template #plainTitle><h2>{{ title }}</h2></ng-template>
    <button *ngIf="sopMode; else defaultClose" class="modal-close modal-close--sop" type="button" [attr.aria-label]="closeLabel" (click)="close.emit()">
      <img src="assets/icon/cancel.svg" alt="">
    </button>
    <ng-template #defaultClose>
      <app-icon-button class="modal-close" icon="close-outline" color="medium" size="sm" [ariaLabel]="closeLabel" (clicked)="close.emit()"></app-icon-button>
    </ng-template>
  </header>
  <div class="modal-shell-body">
    <ng-content></ng-content>
  </div>
  <footer class="modal-shell-footer">
    <ng-content select="[modal-footer]"></ng-content>
  </footer>
</section>